<template>
  <el-dialog
    :title="reportTitle"
    :visible.sync="dialogVisible"
    width="70%"
    append-to-body
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <div v-loading="loading" class="ai-report-dialog">
      <!-- 外链报告（格子达）：直接打开外链并提供下载入口 -->
      <template v-if="!loading && report && report.externReport">
        <div class="extern-tip">
          <i class="el-icon-link"></i>
          <span>该报告由第三方（格子达）生成，点击下方按钮在新窗口查看 / 下载。</span>
        </div>
        <div class="extern-actions">
          <el-button type="primary" size="mini" @click="openExtern"
            >查看格子达报告</el-button
          >
          <el-button size="mini" @click="downloadGzd">下载格子达报告</el-button>
        </div>
      </template>

      <!-- 华宸三段式报告：三个 Tab -->
      <template v-else-if="!loading && report">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="综合智评" name="comprehensive">
            <ComprehensiveReport
              :evaluation="report.evaluation"
              :core-problems="report.coreProblems || []"
              :overall-items="report.overallItems || []"
              :review-file-url="report.reviewFileUrl"
              :dimension-file-url="report.dimensionFileUrl"
              :docx-url="report.docxUrl"
              :paper-name="report.paperName"
            />
          </el-tab-pane>
          <el-tab-pane label="论文对照" name="contrast">
            <PaperContrast
              :paragraphs="report.paragraphs || []"
              :json-url="report.jsonUrl"
            />
          </el-tab-pane>
          <el-tab-pane label="评分要素" name="factor">
            <ScoreFactor :dimension-items="report.dimensionItems || []" />
          </el-tab-pane>
        </el-tabs>
      </template>

      <el-empty v-else-if="!loading" description="未获取到AI报告数据"></el-empty>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="dialogVisible = false"
        >关闭</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getAiReport, downloadGzdReport } from "@/api/ai";
import ComprehensiveReport from "./ai/ComprehensiveReport.vue";
import PaperContrast from "./ai/PaperContrast.vue";
import ScoreFactor from "./ai/ScoreFactor.vue";

export default {
  name: "AiReportDialog",
  components: {
    ComprehensiveReport,
    PaperContrast,
    ScoreFactor,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    logId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      report: null,
      activeTab: "comprehensive",
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    reportTitle() {
      if (!this.report) return "AI评阅报告";
      return this.report.aiType === "gzd" ? "格子达AI质检报告" : "华宸AI智评报告";
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadReport();
      }
    },
  },
  methods: {
    async loadReport() {
      if (!this.logId) {
        this.$message.error("缺少报告标识，无法查看");
        return;
      }
      this.loading = true;
      this.report = null;
      try {
        const res = await getAiReport({ logId: this.logId });
        this.report = res || null;
        // 外链报告：关闭弹窗并跳转外链
        if (this.report && this.report.externReport) {
          this.dialogVisible = false;
          this.$nextTick(() => {
            this.openExtern();
          });
        }
      } catch (e) {
        this.$message.error((e && e.msg) || "获取AI报告失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    openExtern() {
      if (this.report && this.report.reportUrl) {
        window.open(this.report.reportUrl, "_blank");
      }
    },
    downloadGzd() {
      if (!this.logId) return;
      window.open(downloadGzdReport(this.logId), "_blank");
    },
    handleClosed() {
      this.report = null;
      this.activeTab = "comprehensive";
    },
  },
};
</script>

<style scoped lang="scss">
.ai-report-dialog {
  min-height: 200px;
  .extern-tip {
    display: flex;
    align-items: center;
    color: #606266;
    font-size: 14px;
    i {
      color: #409eff;
      font-size: 18px;
      margin-right: 8px;
    }
  }
  .extern-actions {
    margin-top: 18px;
  }
}
</style>
